import { useLocation, useNavigate } from 'react-router-dom';

import APIs from '../../../api';
import { useAlerting, useTranslation } from '../../../hooks';
import useLoading from '../../../hooks/useLoading';
import useRunOnceEffect from '../../../hooks/useRunOnceEffect';
import { clearTokens, getIsRedirectLoginPath } from '../../../utils';
import { writeTokenAndLoginInfo } from '../RedirectForUserAuth';
import { useAppDispatch } from '../../../reducer/hooks';
import { logout } from '../../../reducer/profileSlice';

const APP_PORTAL_LANG_CONVERSION: { [key: string]: string } = {
  en: 'en',
  'zh-TW': 'zh_cn',
};

const RedirectLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { alerting } = useAlerting();
  const { showLoading, hideLoading } = useLoading();
  const { tc, changeLanguage } = useTranslation();
  const dispatch = useAppDispatch();
  // const [, setLocale] = useLocaleState();
  const params = new URLSearchParams(location.search);

  const token = params.get('token');
  const urlLang = params.get('lang') || 'en';

  const lang = APP_PORTAL_LANG_CONVERSION[urlLang] || 'en';

  const redirectToWebPortalLoginPage = (errorMsg?: string) => {
    if (errorMsg && errorMsg.length > 0) {
      alerting('error', errorMsg);
    }

    navigate('/login');
  };

  const appLogin = async () => {
    clearTokens();
    dispatch(logout());

    showLoading('appLogin');
    const res = await APIs.General.AccessToken.appLogin({ accessToken: token });
    hideLoading('appLogin');

    if (!res) {
      return redirectToWebPortalLoginPage();
    }

    changeLanguage(lang);

    // Web Portal Login
    // navigateToRedirect({
    //   accessToken: res.accessToken,
    //   refreshToken: res.refreshToken,
    //   features: res.features,
    // });

    writeTokenAndLoginInfo({
      accessToken: res.accessToken,
      refreshToken: res.refreshToken,
      merchantName: res.merchantName,
      features: res.features,
      appUuid: res.appUuid || '',
      acceptLevel: res.acceptLevel,
    });
    navigate('/');
  };

  useRunOnceEffect(async () => {
    if (!token) {
      redirectToWebPortalLoginPage(tc('tokenNotFound'));
      return;
    }

    if (!getIsRedirectLoginPath()) {
      return;
    }

    await appLogin();
  });

  return <></>;
};

export default RedirectLogin;
